import React from "react";
import Container from "react-bootstrap/Container";
import "@fortawesome/fontawesome-svg-core/styles.css";

const LivingWellCenter1_3_PreSurgical = () => {
  return (
    <div>
      <div className="w-100 legosNewBuild livingWellCenterHeader">
        <section className="mb-0">
          {/* L6 Background image header bar */}
          <div className="lego l006 legoMargin4">
            <div
              className="backgroundImage"
              style={{
                backgroundImage:
                  "url(" +
                  "https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/4946e550fcb6294d4fe781077bba8856.jpeg" +
                  ")",
              }}
            >
              <div
                className="transparentBarTypeContainer"
                style={{
                  backgroundColor: "#8DCA64",
                }}
              >
                &nbsp;&nbsp;
              </div>
              <h2 className="l6SubheadWithBackground">Make an Appointment</h2>
            </div>
          </div>
          {/* End L6 Background image header bar */}
        </section>
        <Container>
          <div className="w-100">
            <div className="col-12 m-auto">
              <div className="whiteBackground floatLeft clearLeft legosNewBuild livingWellCenterHeader">
                <section>
                  {/* L83A Icon Color Bar New */}
                  <div
                    className="lego l083AA legoMargin5"
                    style={{ borderRadius: 0 }}
                  >
                    <img
                      alt=""
                      className="imageW100 noBorderRadius image600"
                      src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/af97876010a2f3cd1e39df819e44ab54.jpeg"
                    />
                    <div className="contentContainer">
                      <p>
                        To schedule an appointment, <br />
                        contact the Living Well Center at
                      </p>
                      <h2 className="boldLeadInNewUI">
                        <a
                          href="tel:3145143565"
                          style={{ color: "inherit", textDecoration: "none" }}
                        >
                          (314) 514-3565
                        </a>
                      </h2>
                    </div>
                  </div>
                  {/* End L83A Icon Color Bar New */}
                </section>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default LivingWellCenter1_3_PreSurgical;
